export default "__VITE_ASSET__Cq4VvoQ2__"